import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomButton from "./CustomButton";
import { Close } from "@mui/icons-material";
import CustomIconButton from "./CustomIconButton";
import NullCheck from "./NullCheck";

const CustomDialog = ({
  open,
  onClose,
  children,
  title,
  actionBtn,
  maxWidth,
  fullScreen = false,
  hidePadding,
  fullWidth = false,
}) => {
  const theme = useTheme()
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  return (
    <Dialog
      maxWidth={maxWidth ?? "xl"}
      sx={{
        "& .MuiDialog-paper": {
          maxHeight: isMobile ? 'auto' : 600,
          padding: hidePadding ? 0 : 0
        },
        "& .MuiBackdrop-root": {
          bgcolor: "rgba(0 , 0, 0, 0.1)",
          backdropFilter: "blur(2px)",
        },
      }}
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      open={open}
      onClose={onClose}
    >
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={5}
        >
          <Typography variant="h6">{t(title)}</Typography>

          <NullCheck valueForCheck={onClose}>
            <CustomIconButton size={30} icon={<Close />} onClick={onClose} />
          </NullCheck>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ padding: hidePadding ? 0 : 0 }} dividers>
        {children}
      </DialogContent>

      <NullCheck valueForCheck={actionBtn}>
        <DialogActions sx={{ gap: 2 }}>
          <CustomButton
            title={t(actionBtn?.title)}
            autoFocus
            color={actionBtn?.color ?? "primary"}
            onClick={() => actionBtn?.onClick()}
          />
        </DialogActions>
      </NullCheck>
    </Dialog>
  );
};
export default CustomDialog;
